module.exports = __webpack_public_path__ + "img/pcrown2.58de01bb.png";